import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '../services/translate.service';
import {MESSAGE_SUFFIX} from '../translate.suffix';
import {Observable} from 'rxjs';

@Pipe({
  name: 'cpMessageTranslate',
  pure: true
})
export class MessageTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(query: string, args: any[] = []): Observable<string> {
    return this.translateService.transform(
      this.translateService.containsRegisteredTranslateSuffix(query) ? query : query + MESSAGE_SUFFIX, ...args);
  }
}
